import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Flex, Label } from 'rebass';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { space, width } from 'styled-system';
import { PvBox, PvButton } from 'styles/CustomComponents';

const PvSearchBtn = styled(PvButton)`
  ${space}
  ${width}
`;

class DataImportUpload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedFile: undefined
    }

  }

  onFileSelected = (event) => {
    if (event.target.files.length) {
      this.setState({ selectedFile: event.target.files[0] });
    }
  }

  upload = (event) => {
    event.preventDefault();
    event.target.reset();
    this.props.uploadFn(this.state.selectedFile);
    this.setState({ selectedFile: undefined });
  }

  render() {

    const { selectedFile } = this.state;

    return (
      <form onSubmit={this.upload}>
        <PvBox my={2}>
          <Flex flexWrap='wrap' alignItems='flex-end'>
            <PvBox display='inline-block' px={2} pb={3}>
              <Label mb={2}>
                <Translate value='dataimport.pick_file' />
              </Label>

              <input type="file" onChange={this.onFileSelected} accept="text/xml" />
            </PvBox>
            <PvBox display='inline-block' px={2} pb={3}>
              <PvSearchBtn
                type="submit" px={3} width='100%'
                disabled={!selectedFile}>
                <Translate value='action.import_file' />
              </PvSearchBtn>
            </PvBox>
          </Flex>
        </PvBox>
      </form>
    )

  }

}


DataImportUpload.propTypes = {
  selectedFile: PropTypes.object,
  uploadFn: PropTypes.func,
};

export default connect()(DataImportUpload);



// WEBPACK FOOTER //
// ./src/containers/dataImport/DataImportUpload.jsx